<template lang="pug">
  BaseForm(
    :title="title"
    :routeKey="routeKey"
    :routes="routes"
    :form="form"
    :data="item"
    :update="updateItem"
    :create="createItem"
  )
</template>

<script>
import BaseForm from '@/components/app/BaseForm'
import { mapState, mapActions } from 'vuex'
import store from '@/store'

export default {
  components: { BaseForm },
  data: (vm) => ({
    title: vm.$t('riders.edit', { id: vm.$route.params.riderId })
  }),
  computed: {
    ...mapState('riders', ['routeKey', 'routes', 'form', 'item']),
    crumbs: vm => [
      { text: vm.$t('riders.title'), to: { name: 'riders.index' } },
      { text: vm.$t('riders.edit', { id: vm.$route.params.riderId }) }
    ]
  },
  async beforeRouteEnter (to, from, next) {
    try {
      await store.dispatch('riders/fetchItem', { route: to })
      await store.dispatch('riders/fetchCategories')
      await store.dispatch('riders/fetchDisciplines')
      await store.dispatch('riders/fetchSiteVersions')
      next()
    } catch (error) {
      next(error)
    }
  },
  methods: {
    ...mapActions('riders', ['createItem', 'updateItem'])
  }
}
</script>
